import { createFileRoute } from "@tanstack/react-router";

function Settings() {
  return (
    <div className="panel">
      <div className="text-xs text-slate-400 uppercase tracking-wide mb-1">
        Admin
      </div>
      <h1 className="text-2xl font-semibold mb-3">Settings</h1>
      <div className="text-sm text-slate-600 mb-4">
        Worker route: <code>GET /api/config</code> (Phase 5)
      </div>
      <div className="stub">
        Manager-editable: pricing tiers, follow-up windows, WhatsApp rate
        limit, AI daily budget, KPI targets. Audit-logged on every change.
      </div>
    </div>
  );
}

export const Route = createFileRoute("/settings/")({ component: Settings });
